import React from 'react'
import moment from 'moment-timezone'
import { Progress } from 'reactstrap';
import {makeStyles, Chip, useTheme} from '@material-ui/core'
import { isUndefined } from 'lodash';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import {useSelector} from 'react-redux'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const useStyles = makeStyles({
  MainProgress: {
    backgroundColor: '#09585C80 !important',
    height:'50px !important',
    borderRadius:"0"
  }
});

function ProgressItem({intl,type, total, endSum, leadingValue, classes, intervalltype, _index, tag, compFinished,Keyword,Color}) {

  const formatNumber=(number)=>{
    if(number > 1000000){
        return `${(number/1000).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}K`
    }else if(number >= 1000){
        return `${(number/1000).toFixed(0)}K`
    }else{
        return number
    }
  }

  const returnValueProgress = (value) => {
    return (value/parseInt(endSum)) * 100 > 100 ? 100 : (value/parseInt(endSum)) * 100
  }

  const returnProgressClass = (value) => {
    if(value > 90) return classes.prog90
    if(value > 50) return classes.prog50
    if(value > 30) return classes.prog30
    return classes.prog30
  }

  const getTag = () => {
    return <Chip label={Keyword} style={{['-webkit-text-stroke']: '0px #fff', backgroundColor: Color, color:'#fff', marginBottom: 6}} size="small" />
  }

  const returnValueFormatByTypeTotal = () => {
    switch(type) {
      //Försäljning
      case 1: return formatNumber(total)
      //Bokade möten
      case 2: return `${total} ${intl.formatMessage({ id: 'DashBoard.contest.Book.Short' })}`
      //Taggar
      case 3: return <>{`${total} `}{getTag()}</>
      //Aktiviteter
      case 4: return `${total} ${intl.formatMessage({ id: 'Activities' })}`
      default: return total
    }
  }
  const returnValueFormatByTypeEnd = () => {
    switch(type) {
      case 1: return formatNumber(endSum)
      case 2: return `${endSum} st`
      case 3: return `${endSum} st`
      case 4: return `${endSum} st`
      default: return endSum
    }
  }

  return (
    <div className='w-100 overflow-hidden'
      style={{height: 50}}
    >
      {
        !compFinished &&
        <div className='position-absolute h-100 w-100' style={{zIndex: -1, height: 110}}>
          <Progress multi className={classes.MainProgress}>
            <Progress bar animated 
              color={"#4bc3c5"}
              value={returnValueProgress(total)} 
              max={100}
            >
            </Progress>
          </Progress>
        </div>
      }
      <div className='d-flex align-items-center justify-content-center h-100 w-100' style={{height: 110}}>
      <h1 className='m-0' style={
        compFinished ?
        {
          fontSize: "140%", 
          fontWeight: 700,
          color: 'rgb(68, 209, 194)',
          ['-webkit-text-stroke']: '2px rgb(84, 243, 227)'
        }:
        {
          fontSize: "140%", 
          fontWeight: 700,
          color: '#fff'
          // color: 'rgb(68, 209, 194)',
          // ['-webkit-text-stroke']: '2px rgb(84, 243, 227)'
          }}>
            {returnValueFormatByTypeTotal()}
            {` / `}
            {returnValueFormatByTypeEnd()}
        </h1>
      </div>
    </div>
  )
}

function GruppMål(props) {

  const classes = useStyles()

  const [activeStep, setActiveStep] = React.useState(0);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const theme = useTheme();
  
  return (
    <>
      <div className='w-100' style={{position: 'absolute', bottom: 0, left: 0}}>
        <AutoPlaySwipeableViews
            disabled
            interval={5000}
            axis={theme.direction === 'rtl' ? 'y-reverse' : 'y'}
            index={activeStep}
            onChangeIndex={handleStepChange}
            enableMouseEvents
            className='w-100'
            style={{height: 50, position: 'relative'}}
            containerStyle={{height: 50}}
          >
            {
              props.Competition.grpData.map((d, _index) => (
              <ProgressItem 
                {...d}
                intl={props.intl}
                _index={_index}
                compFinished={props.Competition.compFinished}
                intervalltype={props.Competition.intervalltype}
                classes={classes}
              />
            ))}
          </AutoPlaySwipeableViews>
      </div>
    </>
  )
}

export default injectIntl(GruppMål);